import { SET_GLOBAL_ALERT } from '../constants'

export default (message: string, success: boolean): { type: string; message: string; success: boolean } => ({
    type: SET_GLOBAL_ALERT,
    message,
    success
})
